export default "__VITE_ASSET__BFEOPwtK__"